module.exports = __webpack_public_path__ + "static/media/light-r-5.21c948b8.png";